// import { Warning } from "@clockwise/design-system/icons";
// import { LockFilled } from "@clockwise/icons";
// import { TradeoffInactionReason } from "@clockwise/schema";
import { EventThread } from "@clockwise/web-commons/src/ui/event-thread/";
import { useUpdateActiveEvent } from "@clockwise/web-commons/src/util/ActiveEventContext";
import { Profile } from "@clockwise/web-commons/src/util/profile.util";
import { isEmpty } from "lodash";
import React from "react";
import { useUpdateHoverEvent } from "../../../../../chat-plus-calendar/util/HoverEventContext";
import { EventCardCollapsed } from "../../../../../event-card/EventCardCollapsed";
import { useAIMessageContext } from "../../../hooks/AIMessageContext";
import { TradeoffBlock } from "../../../utils/types";
import { useEventLayersToggle } from "../../multi-calendar/useEventLayersToggle";

// TODO, will use later in popover
// const getTradeOffTextFromInactionType = (reason: TradeoffInactionReason) => {
//   switch (reason) {
//     case TradeoffInactionReason.ExternalMeeting:
//       return { text: "Unfixable conflict (External attendees)", icon: Warning };
//     case TradeoffInactionReason.LowVisibility:
//       return { text: "Unfixable conflict (No permission)", icon: LockFilled };
//     case TradeoffInactionReason.Other:
//       return { text: "Unfixable conflict (No times found)", icon: Warning };
//     case TradeoffInactionReason.IsActionable:
//       return { text: "Fixable conflict (Suggestion declined)" };
//   }
// };

export const TradeoffEvents = ({ tradeoffs }: { tradeoffs: TradeoffBlock[] }) => {
  const schedulingTradeoffsWithEventId = tradeoffs
    .map((tradeoff) => tradeoff.schedulingTradeoffs)
    .flat()
    .filter((tradeoff) => !isEmpty(tradeoff.externalEventId));

  if (!schedulingTradeoffsWithEventId.length) {
    return null;
  }

  return (
    <>
      {schedulingTradeoffsWithEventId.map((schedulingTradeoff) => (
        <TradeoffEvent
          key={schedulingTradeoff.externalEventId}
          schedulingTradeoff={schedulingTradeoff}
        />
      ))}
    </>
  );
};

const TradeoffEvent = ({
  schedulingTradeoff,
}: {
  schedulingTradeoff: TradeoffBlock["schedulingTradeoffs"][0];
}) => {
  const { processingMessage } = useAIMessageContext();
  const updateActiveEvent = useUpdateActiveEvent();
  const updateHoverEvent = useUpdateHoverEvent();

  const { attendees } = schedulingTradeoff;
  const calendarID = attendees?.[0]?.primaryCalendarId || "";

  const { toggle, disabled, active } = useEventLayersToggle({
    startingIsToggledOn: false,
    externalEventId: schedulingTradeoff.externalEventId || "",
    calendarId: calendarID,
    focusedToggle: true,
  });

  const profiles: Profile[] = attendees.map((attendee) => {
    const profile = {
      givenName: attendee?.profile?.givenName || null,
      familyName: attendee?.profile?.familyName || null,
      externalImageUrl: attendee?.profile?.externalImageUrl || null,
    };
    return profile;
  });

  const handleExpand = () => {
    if (processingMessage || !schedulingTradeoff.externalEventId) return;
    updateActiveEvent({
      externalEventId: schedulingTradeoff.externalEventId,
      calendarId: calendarID,
    });
    updateHoverEvent(null);
  };

  return (
    <EventThread.Event profiles={profiles}>
      <EventCardCollapsed
        eventName={schedulingTradeoff.eventTitle}
        onExpandCard={handleExpand}
        subText={null}
        onToggleLayers={disabled ? undefined : toggle} // Hide toggle if disabled
        isLayersActive={active}
        isLayersDisabled={disabled}
        toggleLayersTooltip="Show attendee calendars"
      />
    </EventThread.Event>
  );
};
